module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('document-container', {
    attrs: {
      "header": _vm.header,
      "logo": _vm.logo,
      "tables": _vm.tables,
      "timeout": 12000,
      "documentType": "equivalence-check"
    }
  }, _vm._l((_vm.config), function(productType) {
    return _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('product-table', {
      attrs: {
        "id": 'product-table-' + productType.entityType,
        "table": _vm.tables.findTable('product-table-' + productType.entityType)
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00a4122c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/equivalence-check/EquivalenceCheck.vue
// module id = 648
// module chunks = 0